const fancyMonthFormat = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

// If we end up making this more complicated we should find a library (but beware bundle size).
// We don't use Gatsby's date formatting because we need it to work in _raw Sanity fields too.
export const fancyDateFormat = (date: string | Date): string => {
  if (date instanceof Date) {
    date = date.toISOString();
  }
  const [year, month, day] = date.split("-").map(s => parseInt(s, 10));
  const dayFormatted = (day < 10 ? "0" : "") + day;
  const monthFormatted = fancyMonthFormat[month - 1];
  return `${dayFormatted} ${monthFormatted} ${year}`;
};

export const getYearFromDate = (dateString: string): string => {
  return new Date(dateString).getFullYear().toString();
};
